import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  LucideAngularModule,
  Sparkles, Search, CloudUpload, FileText, Database,
  CircleCheck, Info, TriangleAlert, CircleX,
  ChevronLeft, ChevronRight, ChevronUp, ChevronDown,
  X, Upload, Save, Check,
  Table, ArrowUp, ArrowDown, SlidersHorizontal, ListFilter,
  GripVertical, EllipsisVertical, Trash2, CircleAlert,
  Scissors, Copy, ClipboardPaste, Move, Plus,
  SearchX, Funnel, RotateCcw,
  Asterisk, Lock, Paperclip, ExternalLink,
} from 'lucide-angular';

// Icons already imported above
import { ChildTableComponent } from './child-table.component';
import { ChildTableEmbeddedComponent } from './child-table-embedded.component';
import { ChildTablePaginationComponent } from './components/pagination/child-table-pagination.component';
import { ChildTableRowMenuComponent } from './components/row-menu/child-table-row-menu.component';
import { ChildTableCustomMoveComponent } from './components/custom-move/child-table-custom-move.component';
import { ChildTableToolbarComponent } from './components/toolbar/child-table-toolbar.component';
import { ChildTableColumnMenuComponent } from './components/column-menu/child-table-column-menu.component';
import { ChildTablePositioningService } from './services/child-table-positioning.service';
import { InlineBannerModule } from '../inline-banner/inline-banner.module';

// Legacy cell editor (still used by the main component template)
import { ChildTableCellEditorComponent } from './components/cell-editor/child-table-cell-editor.component';

// Import modal
import { ImportModalComponent } from './components/import-modal/import-modal.component';

// New modular cell editors
import {
  EditorHostComponent,
  TextEditorComponent,
  NumberEditorComponent,
  DateEditorComponent,
  EmailEditorComponent,
  PhoneEditorComponent,
  TextareaEditorComponent,
  SelectEditorComponent,
  MultiselectEditorComponent,
  CheckboxEditorComponent,
  FileEditorComponent,
} from './components/cell-editors';

@NgModule({
  declarations: [
    ChildTableComponent,
    ChildTableEmbeddedComponent,
    ChildTablePaginationComponent,
    ChildTableRowMenuComponent,
    ChildTableCustomMoveComponent,
    ChildTableToolbarComponent,
    ChildTableColumnMenuComponent,
    ChildTableCellEditorComponent,
    ImportModalComponent,
    // New cell editors
    EditorHostComponent,
    TextEditorComponent,
    NumberEditorComponent,
    DateEditorComponent,
    EmailEditorComponent,
    PhoneEditorComponent,
    TextareaEditorComponent,
    SelectEditorComponent,
    MultiselectEditorComponent,
    CheckboxEditorComponent,
    FileEditorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    InlineBannerModule,
    LucideAngularModule.pick({
      Sparkles, Search, CloudUpload, FileText, Database,
      CircleCheck, Info, TriangleAlert, CircleX,
      ChevronLeft, ChevronRight, ChevronUp, ChevronDown,
      X, Upload, Save, Check,
      Table, ArrowUp, ArrowDown, SlidersHorizontal, ListFilter,
      GripVertical, EllipsisVertical, Trash2, CircleAlert,
      Scissors, Copy, ClipboardPaste, Move, Plus,
      SearchX, Funnel, RotateCcw,
      Asterisk, Lock, Paperclip, ExternalLink,
    }),
  ],
  providers: [ChildTablePositioningService],
  exports: [
    ChildTableComponent,
    ChildTableEmbeddedComponent,
  ],
})
export class ChildTableModule {}
